/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent:require('../list/List'),
    method:{
        init:function () {

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/pagination/List.js
// module id = 58
// module chunks = 1 3 11 12 14 16 17 24 31 33